import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils/mapTableRows";
import {
  Button,
  DocumentsList,
  Modal,
  StatusTags,
  TableAdv,
} from "../../../../../components";
//

import { useSelector, useDispatch } from "react-redux";
import {
  getEmployeeByUiidStart,
  setEmployeeProfileUiid,
} from "../../../../../redux/slices/employee/employeeSlice";
import { getValueByKey, dateFormator } from "../../../../../utils";
import { transformFiles } from "../../../../../utils/transformFiles";
import ViewEverifyModel from "./WorkAuthorizationModals/viewEverifyModel";

const EVerifiy = ({ handleEditEVerifiy }) => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    if (employeeProfileUiid && !loadedTabs.includes("eVerifiyTab")) {
      dispatch(
        getEmployeeByUiidStart({
          uiid: employeeProfileUiid,
          tab: "eVerifiyTab",
          ret: "eVerify",
          ref: "eVerifyDoc",
        })
      );
    }
  }, [employeeProfileUiid, loadedTabs, dispatch]);

  const { eVerify } = employeeDetails || {};

  //const tableData = eVerify ? [eVerify] : [];

  const handelDocumetsModal = (documents) => {
    setSelectedDocuments(documents);
    setIsModalOpen(true);
  };
  const tableData = eVerify || [];

  const columns = [
    { key: "caseNum", label: "E-Varification Case Number" ,
          render: (row) => (
            <span
              className="cursor-pointer text-info"
             onClick={() => handleclickEVerifiy(row)}
            >
              {row.caseNum}
            </span>
          ),  
    },
    {
      key: "date",
      label: "E-Varification Date",
      render: (row) => dateFormator(row.date),
    },
    // { key: "status", label: "E-Varification Status" },
    { key: "verifiedBy", label: "E-Varified By" },
    {
      key: "expiryDate",
      label: "Expiry Date",
      render: (row) => dateFormator(row.expiryDate),
    },
    { key: "status", label: "Status",
       render: (row) => {
    const statusMap = {
      1: "Active",
      2: "Inactive"
    };

    const statusText = statusMap[row?.status] || "Unknown";

    // return <div>{statusText}</div>;
    return <StatusTags tag={statusText} />;
  } },

    {
      key: "documents",
      label: "Documents",
      render: (row) => {
        return (
          <div
            className={`flex items-center gap-1 flex-row ${
              transformFiles(row.documents || []).length > 0 && "cursor-pointer"
            }`}
            onClick={
              transformFiles(row.documents || []).length > 0
                ? () => handelDocumetsModal(transformFiles(row.documents || []))
                : () => {}
            }
          >
            <span
              className={`${
                transformFiles(row.documents || []).length > 0 &&
                "text-linkblue"
              }`}
            >
              {transformFiles(row.documents || []).length} Docs{" "}
            </span>
            <div>
              <Button
                type="icon"
                icon="docs"
                size="xs"
                variant="text"
                color="black"
              />
            </div>
          </div>
        );
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div>
            <Button
              type="icon"
              size="sm"
              color="dark"
              variant="text"
              icon="edit_square"
              onClick={() => handleEditEVerifiy(row)}
            />
          </div>
        );
      },
      sortable: false, // Ensure sorting is disabled for this column
    },
  ];
 const  handleclickEVerifiy=()=>{
  setIsEditModalOpen(true)
 }

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div className="mt-3">
      <TableAdv tableId={`employee_workauthorization_everify`} rows={mappedRows} columns={columns} hideToolBar />
      <Modal
        width="max-w-2xl"
        title={"Document Details"}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
      <ViewEverifyModel
      isOpen={isEditModalOpen}
      onClose={() => setIsEditModalOpen(false)}
      />
    </div>
  );
};

export default EVerifiy;
